<script lang="ts">
export default {
    name: "CountUp",
    inheritAttrs: false,
};  
</script>
<script setup lang="ts">
import { ref, onMounted, onUnmounted, defineExpose } from 'Vue';
import { CountUp } from 'Countup.js';
import { isInViewport } from "@/lib/helper/functions"

interface Props {
    endVal: number, startVal?: number; // number to start at (0)
    decimalPlaces?: number; // number of decimal places (0)
    duration?: number; // animation duration in seconds (2)
    useGrouping?: boolean; // example: 1,000 vs 1000 (true)
    useEasing?: boolean; // ease animation (true)
    smartEasingThreshold?: number; // smooth easing for large numbers above this if useEasing (999)
    smartEasingAmount?: number; // amount to be eased for numbers above threshold (333)
    separator?: string; // grouping separator (,)
    decimal?: string; // decimal (.)
    // easingFn: easing function for animation (easeOutExpo)
    easingFn?: (t: number, b: number, c: number, d: number) => number;
    formattingFn?: (n: number) => string; // this function formats result
    prefix?: string; // text prepended to result
    suffix?: string; // text appended to result
    numerals?: string[]; // numeral glyph substitution
    enableScrollSpy?: boolean; // start animation when target is in view
    scrollSpyDelay?: number; // delay (ms) after target comes into view
    scrollSpyOnce?: boolean; // run only once
}

/*const { endVal, startVal, decimalPlaces, duration, useGrouping, useEasing, smartEasingThreshold,
    smartEasingAmount, separator, decimal, easingFn, formattingFn, prefix, suffix, numerals,
    enableScrollSpy, scrollSpyDelay, scrollSpyOnce }*/ const props = withDefaults(defineProps<Props>(), {
    startVal: () => 0,
    decimalPlaces: () => 0,
    duration: () => 2,
    useGrouping: () => true,
    useEasing: () => true,
    smartEasingThreshold: () => 999,
    smartEasingAmount: () => 333,
    separator: () => ',',
    decimal: () => '.',
    prefix: () => '',
    suffix: () => '',
    enableScrollSpy: () => true,
    scrollSpyDelay: () => 0,
    scrollSpyOnce: () => true,
    easingFn: () => (t: number, b: number, c: number, d: number): number =>
        c * (-Math.pow(2, -10 * t / d) + 1) * 1024 / 1023 + b,
    formattingFn: () => (num: number): string => `${num}`
})

const target = ref<any>(null);

const countUp = ref<CountUp | null>(null)

const start = () => {
    countUp.value && countUp.value?.start()
}

const reset = () => {
    countUp.value && countUp.value?.reset()
}

const pauseResume = () => {
    countUp.value && countUp.value?.pauseResume()
}

const update = (value: number) => {
    countUp.value && countUp.value?.update(value)
}

const runCountUp = () => {
    if (isInViewport(target.value) || !props.enableScrollSpy) {
        if (!countUp.value) {
            countUp.value = new CountUp(target.value, props.endVal, {
                startVal: props.startVal,
                decimalPlaces: props.decimalPlaces,
                duration: props.duration,
                useGrouping: props.useGrouping,
                useEasing: props.useEasing,
                smartEasingThreshold: props.smartEasingThreshold,
                smartEasingAmount: props.smartEasingAmount,
                separator: props.separator,
                decimal: props.decimal,
                // easingFn:easingFn,
                // easingFn: easingFn,
                // formattingFn: formattingFn,
                prefix: props.prefix,
                suffix: props.suffix,
                numerals: props.numerals,
                enableScrollSpy: props.enableScrollSpy,
                scrollSpyDelay: props.scrollSpyDelay,
                scrollSpyOnce: props.scrollSpyOnce,
            });
            if (!props.enableScrollSpy) {
                start();
            }
        }
    } else {
        if (!props.scrollSpyOnce) {
            reset()
            countUp.value = null
        }

    }
}

defineExpose({ start, reset, pauseResume, update, runCountUp })

onMounted(() => {

    window.addEventListener('scroll', runCountUp)
    runCountUp()
});

onUnmounted(() => {
    if (props.enableScrollSpy && props.scrollSpyOnce) {
        if (countUp.value) {
            reset()
        }
        window.removeEventListener('scroll', runCountUp)
    }

})


</script>
<template>
    <div ref="target"></div>
</template>